var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"navigation-item",class:{ 'active': _vm.isActive, 'disabled': _vm.disabled },attrs:{"to":_vm.to}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.isActive ? _vm.icons[1] : _vm.icons[0]}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+" ")]),(_vm.hasIssue)?_c('span',{staticClass:"error-icon"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }